import { render, staticRenderFns } from "./MapView.vue?vue&type=template&id=671afbe9&scoped=true&"
import script from "./MapView.vue?vue&type=script&lang=js&"
export * from "./MapView.vue?vue&type=script&lang=js&"
import style0 from "./MapView.vue?vue&type=style&index=0&id=671afbe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671afbe9",
  null
  
)

export default component.exports